import { render } from "./MoreLocationPage.vue?vue&type=template&id=f0f60ec0&scoped=true"
import script from "./MoreLocationPage.vue?vue&type=script&lang=js"
export * from "./MoreLocationPage.vue?vue&type=script&lang=js"

import "./MoreLocationPage.vue?vue&type=style&index=0&id=f0f60ec0&scoped=true&lang=css"

import exportComponent from "C:\\Projekte\\repos\\datentool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0f60ec0"]])

export default __exports__